<template>
  <Input
    :id="id"
    :name="id"
    type="text"
    :model-value="modelValue"
    @keypress="validateDecimal"
    @input="(e: InputEvent) => emit('update:model-value', (e.target as HTMLInputElement).value)"
  />
</template>

<script setup lang="ts">
import { Input } from '../../ui/input';
import { useDecimalInput } from './useDecimalInput';

type DecimalInputProps = {
  modelValue: string;
  decimalPlaces: number;
  id?: string;
};

const { decimalPlaces } = defineProps<DecimalInputProps>();

const { validateDecimal } = useDecimalInput(decimalPlaces);

type Emits = {
  'update:model-value': [val: string];
};

const emit = defineEmits<Emits>();
</script>
